/**
 * Assign Technician Modal
 * Modal para asignar técnico a una orden de trabajo
 */

import { useState } from "react";
import { Icon } from "@/components/ui";
import styles from "./AssignTechnicianModal.module.css";

interface Technician {
  id: string;
  name: string;
  initials: string;
}

interface AssignTechnicianModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAssign: (technicianId: string, scheduledDate: string) => void;
  technicians: Technician[];
  quoteName?: string;
}

export function AssignTechnicianModal({
  isOpen,
  onClose,
  onAssign,
  technicians,
  quoteName,
}: AssignTechnicianModalProps) {
  const [selectedTechnician, setSelectedTechnician] = useState<string>("");
  const [scheduledDate, setScheduledDate] = useState<string>("");

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedTechnician && scheduledDate) {
      onAssign(selectedTechnician, scheduledDate);
      setSelectedTechnician("");
      setScheduledDate("");
    }
  };

  const handleClose = () => {
    setSelectedTechnician("");
    setScheduledDate("");
    onClose();
  };

  return (
    <div className={styles.overlay} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Asignar Técnico</h2>
          <button className={styles.closeButton} onClick={handleClose}>
            <Icon name="x" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          {quoteName && (
            <div className={styles.quoteInfo}>
              <Icon name="fileText" size={18} />
              <span>Presupuesto: {quoteName}</span>
            </div>
          )}

          <div className={styles.formGroup}>
            <label htmlFor="technician">Técnico Asignado *</label>
            <select
              id="technician"
              value={selectedTechnician}
              onChange={(e) => setSelectedTechnician(e.target.value)}
              required
            >
              <option value="">Selecciona un técnico</option>
              {technicians.map((tech) => (
                <option key={tech.id} value={tech.id}>
                  {tech.name}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="scheduledDate">Fecha Programada *</label>
            <input
              type="date"
              id="scheduledDate"
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              min={new Date().toISOString().split("T")[0]}
              required
            />
          </div>

          <div className={styles.modalFooter}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={handleClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={!selectedTechnician || !scheduledDate}
            >
              <Icon name="check" size={18} />
              Crear Orden de Trabajo
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
